
import StandardButton from "@/components/UI/StandardButton.vue";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { keyboardShortcuts } from "@/lib/keyboard-shortcuts/keyboard-shortcuts";
import { KEYBOARD_SHORTCUTS } from "@/lib/keyboard-shortcuts/global-shortcuts";
import { isUiPanelOpen, toggleUiPanel } from "@/lib/panels/panels";
import TopBarSection from "@/components/Reusable/AppLayout/TopBar/TopBarSection.vue";
import { uiStore } from "@/store/store";

@Component({
  components: {
    StandardButton,
    TopBarSection
  }
})
export default class AddButton extends Vue {
  mounted() {
    if (!uiStore.hasFullAccess) return;
    keyboardShortcuts.register(KEYBOARD_SHORTCUTS.CMD_A, this.toggleAdd);
  }

  toggleAdd() {
    toggleUiPanel("add");
  }

  get isAddSectionOpen() {
    return isUiPanelOpen("add");
  }

  beforeDestroy() {
    keyboardShortcuts.unbind(KEYBOARD_SHORTCUTS.CMD_A);
  }
}
